<template>
	<b-card no-body class="border border-danger p-2" v-if="!_gHlp.isEmpty(activeApprovalList) && _gHlp.checkAccess(['role_credit_head','role_credit_manager','role_admin','role_super_admin'])" v-loading="is_loading">
		<div class="d-flex justify-content-start align-items-center">
			<div class="px-2 text-red">
				<i class="el-icon-warning"></i>
			</div>
			<div class="mb-0  text-red text-left" v-html="currentApproval.message"></div>
			<div class="mb-0  text-info text-left cursor-pointer" v-if="currentApproval.approve_type == 'Case Detail Approval'" @click="showCalculation()">View Detail</div>
			<div class="ml-auto">
				<el-button type="success" plain size="small" @click="updateStatus('Approved')" icon="el-icon-check">
					Approve
				</el-button>
				<el-button type="danger" plain size="small" @click="updateStatus('Rejected')" icon="el-icon-close">
					Reject
				</el-button>
			</div>
		</div>
		<ModalCaseCalculator ref="modal_case_calculator"/>
	</b-card>
</template>

<script>
import { Button } from 'element-ui'
import ModalCaseCalculator from '@/views/CreditLoanCase/Modals/ModalCaseCalculator'
import { mapState, mapActions } from 'pinia';
import { useLoanCaseStore } from '@/stores/loanCaseStore';
import { useApprovalStore } from '@/stores/approvalStore';
import { useNotificationStore } from '@/stores/notificationStore';
import { useMessagingStore } from '@/stores/messagingStore';
import { swal } from '@/assets/js/httpImports.js';
import { gEventBus } from '@/assets/js/EventBus/gEventBus.js'

export default {
	props: ['active_tab'],
	components: {
		ModalCaseCalculator,
		[Button.name]: Button
	},
	data() {
		return {
			is_loading: false,
			tableData: [],
			currentApproval: {}
		}
	},
	created() {
		gEventBus.$on('refresh-approval', this.getListing)
  },
	beforeDestroy() {
		gEventBus.$off('refresh-approval', this.getListing)
	},
	watch: {
		'active_tab': {
			handler(newValue, oldValue) {
				this.getCurrentApproval()
			},
			immediate: true
		},
		'activeApprovalList': {
			handler(newValue, oldValue) {
				this.getCurrentApproval()
			},
			immediate: true
		}
	},
	computed: {
		...mapState(useLoanCaseStore, ['activeCase']),
		...mapState(useApprovalStore, ['activeApprovalList']),
	},
	methods: {
		...mapActions(useApprovalStore, ['getAprovalList', 'updateApproval']),
		...mapActions(useLoanCaseStore, ['getCase']),
		...mapActions(useNotificationStore, ['createBellNotif']),
		...mapActions(useMessagingStore, ['createSendEmail']),
		getListing() {
			if (!_gHlp.isEmpty(this.activeCase)) {
				this.getAprovalList({
					search:{
						custom_key: 'CASE_' + this.activeCase.case_id,
						approve_status: 'Pending'
					},
					paginate:'no_paginate'
				});	
			}
		},
		getCurrentApproval() {
			if (!_gHlp.isEmpty(this.activeApprovalList)) {
				let pendingAproval = [];
				switch (this.active_tab) {
					case 'disbursement':
						pendingAproval = this.tableData.filter(itm => itm.table_name == 'disbursement');
						break;
					case 'collection':
						pendingAproval = this.tableData.filter(itm => ((itm.table_name == 'loan_case' && itm.approve_type == 'Collection Approval') || itm.table_name == 'loan_collection'));
						break;
					case 'redemption':
						pendingAproval = this.tableData.filter(itm => itm.table_name == 'loan_redemption');
						break;
				}
				if (_gHlp.isEmpty(pendingAproval)) {
					pendingAproval = this.activeApprovalList;
				}
				if (!_gHlp.isEmpty(pendingAproval)) {
					this.currentApproval = pendingAproval[0];
				}
			}
		},
		updateStatus(status){
			swal.fire({
				title: 'Approval Confirmation',
				text: "Confirm to " + status + " this request ?",
				showCancelButton: true,
				confirmButtonColor: '#13663E',
				cancelButtonColor: '#8898aa',
				confirmButtonText: 'Confirm',
				reverseButtons: true,
				customClass: {
					title: 'text-left',
					container: 'text-left',
					htmlContainer: 'text-left',
					actions: 'w-100 pr-4 justify-content-end'
				}
			}).then((result) => {
				if (result.isConfirmed) {
					this.is_loading = true;
					let params = { 
						approve_status: status,
						approve_at: _gHlp.getCurrentDateTime(),
						approve_by: _gAuth.activeUser('id',null)
					}
					this.updateApproval(this.currentApproval.apv_id, params).then(resp => {
						gEventBus.$emit('refresh-cases')
						switch (this.currentApproval.table_name) {
							case 'disbursement':{
								this.createBellNotif('LMS_CASE_DISBURSEMENT_APPROVAL',{case_id:this.activeCase.case_id, customer_name:this.activeCase.name, action:status })
								this.createSendEmail('LMS_CASE_DISBURSEMENT_APPROVAL',{case_id:this.activeCase.case_id, customer_name:this.activeCase.name, action:status })
								this.getCase().then(resp => {
									gEventBus.$emit('refresh-disbursements')
								})
								break;
							}
							case 'loan_collection':{
								this.createBellNotif('LMS_CASE_COLLECTION_APPROVAL',{case_id:this.activeCase.case_id, customer_name:this.activeCase.name, action:status })
								this.createSendEmail('LMS_CASE_COLLECTION_APPROVAL',{case_id:this.activeCase.case_id, customer_name:this.activeCase.name, action:status })
								this.getCase().then(resp => {
									gEventBus.$emit('refresh-collections')
								})
								break;
							}
							case 'loan_case':{
								if(this.currentApproval.approve_type == 'Collection Approval'){
									this.createBellNotif('LMS_CASE_COLLECTION_APPROVAL',{case_id:this.activeCase.case_id, customer_name:this.activeCase.name, action:status })
									this.createSendEmail('LMS_CASE_COLLECTION_APPROVAL',{case_id:this.activeCase.case_id, customer_name:this.activeCase.name, action:status })
									gEventBus.$emit('refresh-collection-sum')
								}else if(this.currentApproval.approve_type == 'Case Detail Approval'){
									this.createBellNotif('LMS_CASE_UPDATE_APPROVAL',{case_id:this.activeCase.case_id, customer_name:this.activeCase.name, action:status })
									this.createSendEmail('LMS_CASE_UPDATE_APPROVAL',{case_id:this.activeCase.case_id, customer_name:this.activeCase.name, action:status })
									gEventBus.$emit('refresh-cases')
								}else if(this.currentApproval.approve_type == 'Change Due Date'){
									this.createBellNotif('',{
										status:status,
										user_name:_gAuth.activeUser('name'),
										case_id:this.activeCase.case_id,
										customer_name:this.activeCase.name,
										noti_url: window.location.origin +'/credit-loan-case/detail/'+this.activeCase.case_id+'?active=collection',
										noti_related_type: 'loan_case',
										noti_related_id: this.activeCase.case_id
									},
									'Collection: customer {customer_name} request update due date has been {status} by {user_name}')
									gEventBus.$emit('refresh-collection-sum')
								}else if(this.currentApproval.approve_type == 'Change Full disb Date'){
									this.createBellNotif('',{
										status:status,
										user_name:_gAuth.activeUser('name'),
										case_id:this.activeCase.case_id,
										customer_name:this.activeCase.name,
										noti_url: window.location.origin +'/credit-loan-case/detail/'+this.activeCase.case_id+'?active=disbursement',
										noti_related_type: 'loan_case',
										noti_related_id: this.activeCase.case_id
									},
									'Disbursement: customer {customer_name} request update full disbursement has been {status} by {user_name}')
									gEventBus.$emit('refresh-collection-sum')
								}else{
									this.createBellNotif('',{
										status:status,
										user_name:_gAuth.activeUser('name'),
										case_id:this.activeCase.case_id,
										customer_name:this.activeCase.name,
										noti_url: window.location.origin +'/credit-loan-case/detail/'+this.activeCase.case_id+'?active=overview',
										noti_related_type: 'loan_case',
										noti_related_id: this.activeCase.case_id
									},
									'Loan Case: customer {customer_name} request update has been {status} by {user_name}')
									gEventBus.$emit('refresh-cases')
								}
								break;
							}
						}
						_gNotif.notifySuccess("Approval Request for " + this.currentApproval.approve_type + " has been "+status);
						this.getListing();
						this.is_loading = false;
					}).catch(err => {
						this.is_loading = false;
					});
				}
			});
		},
		showCalculation(){
			this.$refs.modal_case_calculator.show(_gHlp.getValue(this.currentApproval,'data_approve'))
		}	
	},
}
</script>